import { NomineeInfoRowData } from '../../components/home/UpdateNominee/types';
import { INITIALIZE_NOMINEE_ARRAY, UPDATE_NOMINEE_ARRAY } from '../types/nominees';

export type NomineeReducerState = Array<NomineeInfoRowData & {verified?: boolean}>  

function NomineeReducer(
  state: NomineeReducerState= [],
  action: { type: string; body: {payload: any, index: number}},
) {
  switch (action.type) {
    case UPDATE_NOMINEE_ARRAY: {
      const { payload, index } = action.body;
      const tempState = state;
      tempState[index].nominees = payload.data;
      tempState[index].verified = payload.verified;
      tempState[index].noNominee = payload.noNominee || '';
      return state;
    }
    case INITIALIZE_NOMINEE_ARRAY: {
      return action.body.payload;
    }
    default:
      return state;
  }
}

export default NomineeReducer;
